import { Component } from '@angular/core';
import { MainBtnComponent } from "../../UI/main-btn/main-btn.component";

@Component({
  selector: 'app-team-section',
  imports: [],
  templateUrl: './team-section.component.html',
  styleUrl: './team-section.component.css'
})
export class TeamSectionComponent {

}
